import { ClickForMenu, IMenuItem } from "@asup/context-menu";
import React, { MouseEventHandler } from "react";
import styles from "../aic.module.css";

type IconName =
  | "aioxAddDown"
  | "aioxButtonCell"
  | "aioxButtonRowGroup"
  | "aioxButtonRowOptions"
  | "aioxButtonSettings"
  | "aioxCircle"
  | "aioxCircleRed"
  | "aioxDown"
  | "aioxMinus"
  | "aioxPlus"
  | "aioxRemoveUp"
  | "aioxUp";

interface AioIconButtonProps {
  id: string;
  onClick?: MouseEventHandler<HTMLDivElement>;
  iconName?: IconName & keyof typeof styles;
  tipText?: string;
  popUpTip?: boolean;
  menuItems?: IMenuItem[];
  style?: React.CSSProperties;
}

/**
 * Icon button component with optional tooltip and menu.
 *
 * @param props - Destructured parameter object
 * @param props.id - The id for the control
 * @param props.onClick - onClick event handler
 * @param props.iconName - The name of the icon to display
 * @param props.tipText - The tooltip text to display
 * @param props.popUpTip - Whether to show the tooltip as a popup
 * @param props.menuItems - The menu items for the context menu
 * @param props.style - Inline style object applied to the root container element
 */
export const AioIconButton = ({
  id,
  onClick,
  iconName = "aioxDown",
  tipText,
  popUpTip = false,
  menuItems,
  style,
}: AioIconButtonProps): React.ReactElement => (
  <div
    className={styles.aioButtonHolder}
    style={style}
    id={`${id}-holder`}
  >
    <ClickForMenu
      className={[styles.aioTip, styles.flexCenter].join(" ")}
      id={`${id}-menu`}
      menuItems={menuItems}
    >
      <div
        id={id}
        className={[styles.aioxButton, styles[iconName]].join(" ")}
        aria-label={tipText}
        title={tipText}
        role="button"
        onClick={onClick}
      />
      {popUpTip && tipText && (
        <span className={[styles.aioTiptext, styles.aioTipTop].join(" ")}>{tipText}</span>
      )}
    </ClickForMenu>
  </div>
);

AioIconButton.displayName = "AioIconButton";
